module.exports = __webpack_public_path__ + "img/clapperboard.f1da6fa1.svg";